<p>Please get in touch with Charitybooster team to learn more about Donation Products.</p>
<p class="mb-4">
  You can either visit our <a (click)="closeEvent.emit()" [routerLink]="['/', AppRoutes.ContactUs]">Contact</a> page or
  just
  <button (click)="loadChatBox()" class="btn btn-link chat-open text-capitalize p-0 border-0 ms-1">chat now!</button>
</p>
<button (click)="closeEvent.emit()" class="btn btn-black w-100">Continue to explore</button>
